module.exports = __webpack_public_path__ + "img/630f050.png";